document.addEventListener('DOMContentLoaded', function () {
    const mainHeader = document.getElementById('iww-mainheader');
    const stickyHeader = document.getElementById('iww-stickyheader');

    if (mainHeader && stickyHeader) {
        const stickyLogo = document.getElementById('iww-stickyheader-logo');
        const linkToTop = document.getElementById('iww-stickyheader-link-to-top');

        function isElementOutOfView(el) {
            const rect = el.getBoundingClientRect();
            return rect.bottom <= 0;
        }

        function onScroll() {
            if (isElementOutOfView(mainHeader)) {
                stickyHeader.classList.add('fixed');
                stickyLogo.classList.remove('hidden');
                linkToTop.classList.remove('hidden');
            } else {
                stickyHeader.classList.remove('fixed');
                stickyLogo.classList.add('hidden')
                linkToTop.classList.add('hidden');
            }
        }

        window.addEventListener('scroll', onScroll);
        // initial check
        onScroll();
    }
});
